import { h, FunctionalComponent } from "preact";
type VerticalSpaceProps = {
  space: "extraSmall" | "small" | "medium" | "large";
};
export const VerticalSpace: FunctionalComponent<VerticalSpaceProps> = (
  props
) => {
  let height = "4px";

  if (props.space === "small") {
    height = "8px";
  } else if (props.space === "medium") {
    height = "12px";
  } else if (props.space === "large") {
    height = "16px";
  } else if (props.space === "extraSmall") {
    height = "4px";
  }

  return <div style={{ height }} />;
};
